/*

	NOTICE!
	This file was generated automatically
	This is not code!

*/

import { EventType } from 'Utility/Helpers/Events/EventType';
import { PopupID } from 'State/UI/PopupID';
import { BlackFridayEventOfferLayout } from 'Layouts/Events/blackfriday_2023/eventOfferPopup/BlackFridayEventOfferLayout';
import { EasterFTUXLayout } from 'Layouts/Events/easter_2024/eventFTUX/EasterFTUXLayout';
import { EasterEventOfferLayout } from 'Layouts/Events/easter_2024/eventOfferPopup/EasterEventOfferLayout';
import { EasterEventFieldHarvestLayout } from 'Layouts/Events/easter_2024/fieldHarvestMenu/EasterEventFieldHarvestLayout';
import { EasterEventLevelCompletePopupLayout } from 'Layouts/Events/easter_2024/levelCompletePopup/EasterEventLevelCompletePopupLayout';
import { EasterEventLevelPopupLayout } from 'Layouts/Events/easter_2024/levelPopup/EasterEventLevelPopupLayout';
import { EasterEventLevelPopupSideMenuLayout } from 'Layouts/Events/easter_2024/levelPopupSideMenu/EasterEventLevelPopupSideMenuLayout';
import { EasterPlinkoMinigameLayout } from 'Layouts/Events/easter_2024/plinkoMiniGame/EasterPlinkoMinigameLayout';
import { EasterEventQuestsPopupLayout } from 'Layouts/Events/easter_2024/questsMenu/EasterEventQuestsPopupLayout';
import { Halloween2022FTUXLayout } from 'Layouts/Events/halloween_2022/eventFTUX/Halloween2022FTUXLayout';
import { HalloweenEventOfferLayout } from 'Layouts/Events/halloween_2022/eventOfferPopup/HalloweenEventOfferLayout';
import { HalloweenEventFieldHarvestLayout } from 'Layouts/Events/halloween_2022/fieldHarvestMenu/HalloweenEventFieldHarvestLayout';
import { HalloweenEventLevelCompletePopupLayout } from 'Layouts/Events/halloween_2022/levelCompletePopup/HalloweenEventLevelCompletePopupLayout';
import { HalloweenEventLevelPopupLayout } from 'Layouts/Events/halloween_2022/levelPopup/HalloweenEventLevelPopupLayout';
import { HalloweenEventLevelPopupSideMenuLayout } from 'Layouts/Events/halloween_2022/levelPopupSideMenu/HalloweenEventLevelPopupSideMenuLayout';
import { HalloweenPlinkoMinigameLayout } from 'Layouts/Events/halloween_2022/plinkoMiniGame/HalloweenPlinkoMinigameLayout';
import { HalloweenEventQuestsPopupLayout } from 'Layouts/Events/halloween_2022/questsMenu/HalloweenEventQuestsPopupLayout';
import { Jul42022FTUXLayout } from 'Layouts/Events/jul4_2022/eventFTUX/Jul42022FTUXLayout';
import { Jul4EventOfferLayout } from 'Layouts/Events/jul4_2022/eventOfferPopup/Jul4EventOfferLayout';
import { Jul4EventFieldHarvestLayout } from 'Layouts/Events/jul4_2022/fieldHarvestMenu/Jul4EventFieldHarvestLayout';
import { Jul4EventLevelCompletePopupLayout } from 'Layouts/Events/jul4_2022/levelCompletePopup/Jul4EventLevelCompletePopupLayout';
import { Jul4EventLevelPopupLayout } from 'Layouts/Events/jul4_2022/levelPopup/Jul4EventLevelPopupLayout';
import { Jul4EventLevelPopupSideMenuLayout } from 'Layouts/Events/jul4_2022/levelPopupSideMenu/Jul4EventLevelPopupSideMenuLayout';
import { Jul4EventQuestsPopupLayout } from 'Layouts/Events/jul4_2022/questsMenu/Jul4EventQuestsPopupLayout';
import { ValentinesEventOfferLayout } from 'Layouts/Events/valentines_2023/eventOfferPopup/ValentinesEventOfferLayout';
import { ChristmasOfferLayout } from 'Layouts/Events/xmas_2021/eventOfferPopup/ChristmasOfferLayout';
import { EventFieldHarvestLayout } from 'Layouts/Events/xmas_2021/fieldHarvestMenu/EventFieldHarvestLayout';
import { EventLevelCompletePopupLayout } from 'Layouts/Events/xmas_2021/levelCompletePopup/EventLevelCompletePopupLayout';
import { EventLevelPopupLayout } from 'Layouts/Events/xmas_2021/levelPopup/EventLevelPopupLayout';
import { EventLevelPopupSideMenuLayout } from 'Layouts/Events/xmas_2021/levelPopupSideMenu/EventLevelPopupSideMenuLayout';
import { EventQuestsPopupLayout } from 'Layouts/Events/xmas_2021/questsMenu/EventQuestsPopupLayout';
import { Xmas2022FTUXLayout } from 'Layouts/Events/xmas_2022/eventFTUX/Xmas2022FTUXLayout';
import { Christmas2022OfferLayout } from 'Layouts/Events/xmas_2022/eventOfferPopup/Christmas2022OfferLayout';
import { Xmas2022EventFieldHarvestLayout } from 'Layouts/Events/xmas_2022/fieldHarvestMenu/Xmas2022EventFieldHarvestLayout';
import { Xmas2022EventLevelCompletePopupLayout } from 'Layouts/Events/xmas_2022/levelCompletePopup/Xmas2022EventLevelCompletePopupLayout';
import { Xmas2022EventLevelPopupLayout } from 'Layouts/Events/xmas_2022/levelPopup/Xmas2022EventLevelPopupLayout';
import { Xmas2022EventLevelPopupSideMenuLayout } from 'Layouts/Events/xmas_2022/levelPopupSideMenu/Xmas2022EventLevelPopupSideMenuLayout';
import { Christmas2022PlinkoMinigameLayout } from 'Layouts/Events/xmas_2022/plinkoMiniGame/Christmas2022PlinkoMinigameLayout';
import { Xmas2022EventQuestsPopupLayout } from 'Layouts/Events/xmas_2022/questsMenu/Xmas2022EventQuestsPopupLayout';
import { Xmas2023FTUXLayout } from 'Layouts/Events/xmas_2023/eventFTUX/Xmas2023FTUXLayout';
import { Christmas2023OfferLayout } from 'Layouts/Events/xmas_2023/eventOfferPopup/Christmas2023OfferLayout';
import { Xmas2023EventFieldHarvestLayout } from 'Layouts/Events/xmas_2023/fieldHarvestMenu/Xmas2023EventFieldHarvestLayout';
import { Xmas2023EventLevelCompletePopupLayout } from 'Layouts/Events/xmas_2023/levelCompletePopup/Xmas2023EventLevelCompletePopupLayout';
import { Xmas2023EventLevelPopupLayout } from 'Layouts/Events/xmas_2023/levelPopup/Xmas2023EventLevelPopupLayout';
import { Xmas2023EventLevelPopupSideMenuLayout } from 'Layouts/Events/xmas_2023/levelPopupSideMenu/Xmas2023EventLevelPopupSideMenuLayout';
import { Christmas2023PlinkoMinigameLayout } from 'Layouts/Events/xmas_2023/plinkoMiniGame/Christmas2023PlinkoMinigameLayout';
import { Xmas2023EventQuestsPopupLayout } from 'Layouts/Events/xmas_2023/questsMenu/Xmas2023EventQuestsPopupLayout';

export const EventLayoutMap: Partial<Record<EventType, Partial<{[key in PopupID]: any}>>> = {
    ['blackfriday_2023']: {

    ['eventOfferPopup']: BlackFridayEventOfferLayout,
}
,
    ['easter_2024']: {

    ['eventFTUX']: EasterFTUXLayout,
    ['eventOfferPopup']: EasterEventOfferLayout,
    ['fieldHarvestMenu']: EasterEventFieldHarvestLayout,
    ['levelCompletePopup']: EasterEventLevelCompletePopupLayout,
    ['levelPopup']: EasterEventLevelPopupLayout,
    ['levelPopupSideMenu']: EasterEventLevelPopupSideMenuLayout,
    ['plinkoMiniGame']: EasterPlinkoMinigameLayout,
    ['questsMenu']: EasterEventQuestsPopupLayout,
}
,
    ['halloween_2022']: {

    ['eventFTUX']: Halloween2022FTUXLayout,
    ['eventOfferPopup']: HalloweenEventOfferLayout,
    ['fieldHarvestMenu']: HalloweenEventFieldHarvestLayout,
    ['levelCompletePopup']: HalloweenEventLevelCompletePopupLayout,
    ['levelPopup']: HalloweenEventLevelPopupLayout,
    ['levelPopupSideMenu']: HalloweenEventLevelPopupSideMenuLayout,
    ['plinkoMiniGame']: HalloweenPlinkoMinigameLayout,
    ['questsMenu']: HalloweenEventQuestsPopupLayout,
}
,
    ['jul4_2022']: {

    ['eventFTUX']: Jul42022FTUXLayout,
    ['eventOfferPopup']: Jul4EventOfferLayout,
    ['fieldHarvestMenu']: Jul4EventFieldHarvestLayout,
    ['levelCompletePopup']: Jul4EventLevelCompletePopupLayout,
    ['levelPopup']: Jul4EventLevelPopupLayout,
    ['levelPopupSideMenu']: Jul4EventLevelPopupSideMenuLayout,
    ['questsMenu']: Jul4EventQuestsPopupLayout,
}
,
    ['valentines_2023']: {

    ['eventOfferPopup']: ValentinesEventOfferLayout,
}
,
    ['xmas_2021']: {

    ['eventOfferPopup']: ChristmasOfferLayout,
    ['fieldHarvestMenu']: EventFieldHarvestLayout,
    ['levelCompletePopup']: EventLevelCompletePopupLayout,
    ['levelPopup']: EventLevelPopupLayout,
    ['levelPopupSideMenu']: EventLevelPopupSideMenuLayout,
    ['questsMenu']: EventQuestsPopupLayout,
}
,
    ['xmas_2022']: {

    ['eventFTUX']: Xmas2022FTUXLayout,
    ['eventOfferPopup']: Christmas2022OfferLayout,
    ['fieldHarvestMenu']: Xmas2022EventFieldHarvestLayout,
    ['levelCompletePopup']: Xmas2022EventLevelCompletePopupLayout,
    ['levelPopup']: Xmas2022EventLevelPopupLayout,
    ['levelPopupSideMenu']: Xmas2022EventLevelPopupSideMenuLayout,
    ['plinkoMiniGame']: Christmas2022PlinkoMinigameLayout,
    ['questsMenu']: Xmas2022EventQuestsPopupLayout,
}
,
    ['xmas_2023']: {

    ['eventFTUX']: Xmas2023FTUXLayout,
    ['eventOfferPopup']: Christmas2023OfferLayout,
    ['fieldHarvestMenu']: Xmas2023EventFieldHarvestLayout,
    ['levelCompletePopup']: Xmas2023EventLevelCompletePopupLayout,
    ['levelPopup']: Xmas2023EventLevelPopupLayout,
    ['levelPopupSideMenu']: Xmas2023EventLevelPopupSideMenuLayout,
    ['plinkoMiniGame']: Christmas2023PlinkoMinigameLayout,
    ['questsMenu']: Xmas2023EventQuestsPopupLayout,
}
,
}
